module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABbUlEQVRYR+1Xy23CQBScsYBcFzpACrnGqQB3ENoIOQAVJFSAc8C0QTpwKohzxUiUkL3GIL9ojXJBC7KNJR9in6zd95md1XtvhwCgFjvldPYLAVySrlk7/VJgpscD37Z3uqaCeOoAC5utiEQEojRpz/Ssr2mSs3PYkVAieDebVgAOQv00CHMBWMWek8KzAsgOiUcRaElaffaWWx+USSryoJ/vrMnzJC1io5Yb1yE/IXxjN9hEAPX3eGBFXCRwEdtuEGds8u+nDgAEhg2AhoH6GTBdC0SUt8kUKbVLtmoVexC4rCpg2TgNgPoZ6C3jVyGGZe/wGj8KPmiqgMDomkBlfQVY138FZdFX5dcwQFMFKRnp8e26KlrzxFHBduSIuPUPo+ZJ1jDwrxnIhInpAyBe6pFmmB/F6c0+JHgvwFnxKcQ877vRNBlCJucaEgFPIF/y0/ayWXCU54ep0K5ojY0ZnUXk+aURT0GYJi3fyPNfyB/a1ApOUr0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scan.png
// module id = 7k9H
// module chunks = 0